import React from "react";
import ReactDOM from "react-dom/client";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as Sentry from "@sentry/react";
import ErrorBoundary from "./components/ErrorBoundary";
import { isCordova } from "./utils/constants";
import ReactGA from "react-ga4";

const Router = isCordova ? HashRouter : BrowserRouter;

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT;

if (process.env.REACT_APP_GA_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (isCordova) {
  const script = document.createElement("script");
  script.src = "cordova.js";
  script.async = true;
  document.body.appendChild(script);

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = "/styles/mobile-app.css";
  document.head.appendChild(link);
}

if (process.env.REACT_APP_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: "https://e75ed2910ad2355f07e7899d41184955@o4507334530236416.ingest.de.sentry.io/4507334532005968",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

root.render(
  <Router>
    <ErrorBoundary>
      {isCordova ? (
        <App />
      ) : (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || ""}>
          <App />
        </GoogleOAuthProvider>
      )}
    </ErrorBoundary>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
